import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-lib-hover',
  templateUrl: './ds-lib-hover.component.html',
  styleUrls: ['./ds-lib-hover.component.scss'],
})
export class DsLibHoverComponent {
  /**
   * Predefined color values
   */
  @Input() color: 'white' | 'black' | 'primary' | 'menu' = 'white';

  /**
   * predefined gap values (small = 4px gap on all sides, medium = 8px, big = 12px)
   */
  @Input() gap: 'small' | 'medium' | 'big' = 'small';
}
